import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MenuService } from 'app/Shared/Services/menu.service';
// import { Menu2 } from 'app/Shared/models/menu.model';

@Component({
  selector: 'dynamic-sidebar-list',
  templateUrl: './dynamic-sidebar-list.component.html',
  styleUrls: ['./dynamic-sidebar-list.component.css']
})
export class DynamicSidebarListComponent implements OnInit, OnDestroy {

  // rootMenus: Menu2[] = [];
  rootMenus: any = [];

  loading: boolean = false;

  private menusSub!: Subscription;

  constructor(
    private menuService: MenuService
  ) { }

  ngOnInit(): void {
    this.menusSub = this.menuService.menus$.subscribe(menus => {
      this.rootMenus = menus;
      console.log("this.rootMenus : ", this.rootMenus);
    });
  }

  ngOnDestroy(): void {
    this.menusSub?.unsubscribe();
  }

  sendToSupport(): void {
    const supportEmail = 'support@fractalite.com';
    const subject = encodeURIComponent('Demande de support');
    const body = encodeURIComponent('Bonjour,\n\nJe rencontre un problème avec ...');

    // URL Gmail pour composer un nouveau message
    const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&to=${supportEmail}&su=${subject}&body=${body}`;

    try {
      // Ouvrir Gmail dans un nouvel onglet
      window.open(gmailComposeUrl, '_blank');
    } catch (error) {
      console.error('Erreur lors de l\'ouverture de Gmail', error);
      alert('Impossible d\'ouvrir Gmail. Vérifiez votre connexion Internet.');
    }
  }
}
